module.exports = "/fonts/vendor/primeicons/primeicons.ttf?91bacab1f083f2795272499faf7e83dc";